import { baseApi } from '@/services'
import { Escalation } from '@/types/unlock'

export const escalationsApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getEscalations: builder.query<Escalation[], string | string[]>({
      query: (externalId) => `v2/escalations?application__external_id=${externalId}`,
      providesTags: ['Escalations'],
    }),
    updateEscalation: builder.mutation<Escalation, Partial<Escalation>>({
      query: (body: Partial<Escalation>) => ({
        method: 'PATCH',
        url: `v2/escalations/${body.uuid}/`,
        body,
      }),
      invalidatesTags: [
        'Escalations',
        'ApplicationExceptions',
        'AutomatedApplicationExceptions',
        'AtypicalityCheckCalcs',
        'ApplicationCalcs',
        'Override',
        'ApplicationOffer',
        'StreamingNote',
        'Alert',
      ],
    }),
    createEscalation: builder.mutation<Escalation, Partial<Escalation>>({
      query: (body: Partial<Escalation>) => ({
        method: 'POST',
        url: `v2/escalations/`,
        body,
      }),
      invalidatesTags: [
        'Escalations',
        'AtypicalityCheckCalcs',
        'ApplicationCalcs',
        'MaxActions',
        'Alert',
      ],
    }),
    countEscalations: builder.query<number, number>({
      query: (id) => ({
        method: 'GET',
        url: `v2/escalations/count-escalations/?application__id=${id}`,
      }),
      providesTags: ['Escalations'],
    }),
    markAsSeenEscalations: builder.mutation<void, any>({
      query: (body) => ({
        method: 'PATCH',
        url: `v2/escalations/mark-as-seen/`,
        body,
      }),
      invalidatesTags: ['Escalations'],
    }),
  }),
})
export const {
  useGetEscalationsQuery,
  useLazyGetEscalationsQuery,
  useUpdateEscalationMutation,
  useCreateEscalationMutation,
  useCountEscalationsQuery,
  useMarkAsSeenEscalationsMutation,
} = escalationsApi
